import gettext from '@sdk/lang/gettext';

import { EditFormValidationResults } from '@web/timesheets/EditTimesheetModal/editTimesheetModal.types';
import { validateTimeClockFormSection } from '@web/timesheets/CreateTimesheetModal/utils/validation';

export const validateEditTimesheetForm = ({ date, timeClock }) => {
  const validationResults: EditFormValidationResults = {};

  if (!date) {
    validationResults.date = gettext('Date is required');
  }

  return {
    ...validationResults,
    ...validateTimeClockFormSection(timeClock, date),
  };
};
